/**
 * Syncs quote text + preview thumbnails with the main image Swiper (slideshow-section).
 */
function getBlockIndexFromSwiper(swiper) {
  const slide = swiper.slides[swiper.activeIndex];
  return slide?.getAttribute("data-index") || null;
}

function updatePanels(root, blockIndex) {
  if (!blockIndex) return;

  root.querySelectorAll(".wt-expert-says__content-container__text").forEach((el) => {
    el.classList.toggle("is-active", el.getAttribute("data-index") === blockIndex);
  });

  root.querySelectorAll(".wt-expert-says__preview-btn[data-slide-to]").forEach((btn) => {
    btn.classList.toggle("is-active", btn.getAttribute("data-index") === blockIndex);
  });
}

function bindPreviewClicks(root, slideshow) {
  root.addEventListener("click", (event) => {
    const btn = event.target.closest(".wt-expert-says__preview-btn[data-slide-to]");
    if (!btn || !slideshow.swiper) return;
    const i = Number.parseInt(btn.getAttribute("data-slide-to"), 10);
    if (Number.isNaN(i)) return;
    const { swiper } = slideshow;
    if (swiper.params.loop && typeof swiper.slideToLoop === "function") {
      swiper.slideToLoop(i);
    } else {
      swiper.slideTo(i);
    }
  });
}

function waitForSwiper(slideshow, callback, maxFrames = 120) {
  let frames = 0;
  const tick = () => {
    if (slideshow.swiper) {
      callback(slideshow.swiper);
      return;
    }
    frames += 1;
    if (frames < maxFrames) {
      requestAnimationFrame(tick);
    }
  };
  requestAnimationFrame(tick);
}

function initExpertSays(root) {
  if (!root) return;
  if (root.dataset.expertSaysBound === "1" || root.dataset.expertSaysBound === "pending") return;

  const slideshow = root.querySelector("slideshow-section");
  if (!slideshow) return;

  root.dataset.expertSaysBound = "pending";

  waitForSwiper(slideshow, (swiper) => {
    root.dataset.expertSaysBound = "1";

    const onSlideChange = () => {
      const idx = getBlockIndexFromSwiper(swiper);
      if (idx) updatePanels(root, idx);
    };

    swiper.on("slideChange", onSlideChange);
    onSlideChange();

    bindPreviewClicks(root, slideshow);
  });
}

function initAll() {
  document.querySelectorAll("[data-wt-expert-says]").forEach(initExpertSays);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initAll);
} else {
  initAll();
}

document.addEventListener("shopify:section:load", (event) => {
  const root = event.target?.querySelector?.("[data-wt-expert-says]");
  if (root) {
    root.removeAttribute("data-expert-says-bound");
    initExpertSays(root);
  }
});
